let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kkvNl")).then(() => parcelRequire('1gsTt'));